// lib
import { useState, useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import { Button } from 'primereact/button'
import { Slider } from 'primereact/slider'

// styles
import style from '@aytm/app/stats/page/sidebar/view-options/styles/ViewOptionsPanel.module.scss'

const ArtificialResponses = ({ data, generatingArtificialResponses, disabled, onGenerateArtificialResponses }) => {
  const { questions } = data

  const [artificialResponsesIndex, setArtificialResponsesIndex] = useState(0)

  const artificialResponsesOptions = useMemo(() => {
    const min = (questions.some(q => ['cjc', 'cjd', 'md'].includes(q.type)) && 400) || 100
    const max = 5000

    return Array.from({ length: max - min + 1 }, (_, i) => i + min).reduce((acc, cur) => {
      if ((800 > cur && 0 == cur % 10) || (800 <= cur && 3100 > cur && 0 == cur % 50) || (3000 < cur && 0 == cur % 100))
        acc.push([cur, String(cur)])
      return acc
    }, [])
  }, [questions])

  return (
    <div className={style.section}>
      <div className={style['component-title']}>Artificial Responses</div>

      <div className={`${style.row} ${style['row-slider']}`}>
        <div className="p-fluid p-col-12">
          <Slider
            data-testid="stat-view-options-artificial-responses-selector"
            min={0}
            max={artificialResponsesOptions.length - 1}
            value={artificialResponsesIndex}
            labelTemplate={value => artificialResponsesOptions[value][1]}
            disabled={generatingArtificialResponses || disabled}
            onChange={
              generatingArtificialResponses || disabled ? null : event => setArtificialResponsesIndex(event.value)
            }
          />
        </div>
      </div>
      <div className={style.row}>
        <Button
          data-testid="stat-view-options-artificial-responses-button"
          className="p-button-rounded p-button-blue"
          label={generatingArtificialResponses ? 'Generating responses' : 'Generate responses'}
          loading={generatingArtificialResponses}
          disabled={generatingArtificialResponses || disabled}
          onClick={
            generatingArtificialResponses || disabled
              ? null
              : () => onGenerateArtificialResponses(artificialResponsesOptions[artificialResponsesIndex][0])
          }
        />
      </div>
    </div>
  )
}

ArtificialResponses.propTypes = {
  data: PropTypes.object,
  generatingArtificialResponses: PropTypes.bool,
  disabled: PropTypes.bool,
  onGenerateArtificialResponses: PropTypes.func
}

ArtificialResponses.displayName = 'ArtificialResponses'

export default ArtificialResponses
